import { Typography } from '@mui/material';
import { BaseSwitch } from './formElements/switches/BaseSwitch';

interface CoverageSectionSelectionProps {
  isRequired: boolean;
  isDeclined: boolean;
  symbol: string;
  scope: string;
  onToggle: (enabled: boolean) => void;
}

export const CoverageSectionSelection = ({
  isRequired,
  isDeclined,
  symbol,
  scope,
  onToggle,
}: CoverageSectionSelectionProps) => {
  if (isRequired) {
    return (
      <Typography
        variant='body2'
        color='text.secondary'
      >
        Required
      </Typography>
    );
  }

  return (
    <BaseSwitch
      checked={!isDeclined}
      onChange={onToggle}
      id={`${symbol}-${scope}-declined`}
      fireAnalytics={false}
    />
  );
};
